import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServicesAndPricingPage from "./pages/ServicesAndPricingPage";
import GalleryPage from "./pages/GalleryPage";
import PricingPage from "./pages/PricingPage";
import BookingPage from "./pages/BookingPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAgenda from "./pages/AdminAgenda";
import AdminSettings from "./pages/AdminSettings";
import AdminContentEditor from "./pages/AdminContentEditor";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import { AuthProvider } from "./contexts/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Pages publiques avec Header/Footer */}
            <Route path="/" element={
              <div>
                <Header />
                <HomePage />
                <Footer />
                <WhatsAppButton />
              </div>
            } />
            <Route path="/services" element={
              <div>
                <Header />
                <ServicesAndPricingPage />
                <Footer />
              </div>
            } />
            <Route path="/galerie" element={
              <div>
                <Header />
                <GalleryPage />
                <Footer />
                <WhatsAppButton />
              </div>
            } />
            <Route path="/tarifs" element={
              <div>
                <Header />
                <ServicesAndPricingPage />
                <Footer />
                <WhatsAppButton />
              </div>
            } />
            <Route path="/reservation" element={
              <div>
                <Header />
                <BookingPage />
                <Footer />
                <WhatsAppButton />
              </div>
            } />
            <Route path="/contact" element={
              <div>
                <Header />
                <ContactPage />
                <Footer />
                <WhatsAppButton />
              </div>
            } />
            
            {/* Pages administrateur (sans Header/Footer) */}
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/agenda" element={<AdminAgenda />} />
            <Route path="/admin/messages" element={<AdminPage />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/content" element={<AdminContentEditor />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;